var path = 'app/scripts/modules/kubernetes/src/pipeline/stages/disableAsg/disableAsgStage.html';
var html = "<div ng-controller=\"kubernetesDisableAsgStageController as disableAsgStageController\" class=\"form-horizontal\">\n  <div ng-if=\"!pipeline.strategy\">\n\n    <account-namespace-cluster-selector\n      application=\"application\"\n      component=\"stage\"\n      accounts=\"accounts\">\n    </account-namespace-cluster-selector>\n\n  </div>\n  <stage-config-field label=\"Target\">\n    <target-select model=\"stage\" options=\"targets\"></target-select>\n  </stage-config-field>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/scripts/modules/kubernetes/src/pipeline/stages/disableAsg/disableAsgStage.html
// module id = 1487
// module chunks = 0